import * as ng from 'angular';

export const DropzoneMessage = () => (<angular.IDirective>{

    restrict: 'E',
    require: '^dropzone',
    //            transclude: true,
    scope: false,
    template: '<span><i class="icon-icon_dragdrop farchismall-2x" aria-hidden="true"></i> {{message}} </span>',
    //            link: function (scope) {
    //            }
});




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/dropzone-message/dropzone-message.directive.ts